export function getBehaviorsSessionStorage() {
    const sessionItem = sessionStorage.getItem("eK-behaviors");
    return sessionItem ? JSON.parse(sessionItem) : null;
}

export function getChatButtonSessionStorage() {
    const sessionData = sessionStorage.getItem("eK-chat-button-animation");
    return sessionData ? JSON.parse(sessionData) : true;
}

export function getChoiceMessagesSessionStorage() {
    const sessionData = sessionStorage.getItem("eK-chat-choice-messages");
    return sessionData ? JSON.parse(sessionData) : null;
}
